module.exports = __webpack_public_path__ + "img/logo-pga-complete-color.b5bc9ad1.png";